import React from 'react';
import Modal from '../../../../../components/Modal';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation, faXmark } from '@fortawesome/free-solid-svg-icons';
import { useAssignmentContext } from '../../../context';
import { useEffect } from 'react';
import { useState } from 'react';

const WarningAlert = ({
  isOpen,
  onClose,
  isLoading,
  replaceName,
  content,
  setContent,
  contentWidth,
  saveButton,
  cancelButton,
  replaceData,
  validateData
}) => {
  const [temporaryAssignmentName, setTemporaryAssignmentName] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);
  const { saveAs, setSaveAs, neverShow, setNeverShow } = useAssignmentContext();

  const selectedAssignment = useAssignmentContext();

  const handleAssignmentName = (event) => {
    const name = event.target.value;
    setTemporaryAssignmentName(name);
  };

  const saveAsHandler = () => {
    setSaveAs(true);
    setNeverShow(false);
    setContent('');
  };

  const replaceHandler = () => {
    replaceData();
    setIsDisabled(isLoading);
  };
  
  useEffect(() => {
    const suggestedName = selectedAssignment.assignmentName + '[1]';
    setTemporaryAssignmentName(suggestedName);
  }, [isOpen]);
  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        replaceName={replaceName}
        content={content}
        contentWidth={contentWidth}
        hideHeader={true}
        saveButton={saveButton}
        cancelButton={cancelButton}>
        <div className="warning-wrapper pt-3">
          <div className="warning-content p-3">
            <div className="heading-wrapper d-flex gap-2">
              <FontAwesomeIcon icon={faTriangleExclamation} className="triangle-exclamation" />
              {neverShow && (
                <FontAwesomeIcon
                  icon={faXmark}
                  className={`${saveAs ? 'd-none' : 'warning-close'}`}
                  onClick={onClose}
                />
              )}
              <div>
                <h5 className="warning-heading">WARNING</h5>
              </div>
            </div>
            {neverShow && (
              <div>
                <div>
                  <p className="mt-3 mb-0">{content}</p>
                </div>
                <div className="mt-4">
                  <div className="d-flex align-items-center gap-3">
                    {replaceName && (
                      <div
                        className="d-inline-block mb-3 px-3 py-2 replace-btn rounded-2"
                        onClick={replaceHandler}
                        disabled={isDisabled}>
                        Yes, replace it
                      </div>
                    )}
                    <div
                      className="d-inline-block replace-btn rounded-2 px-3 py-2 mb-3"
                      onClick={saveAsHandler}>
                      {replaceName ? 'No, save as' : 'Yes, save as'}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {!neverShow && (
              <div className="mt-4">
                <label className="form-check-label">Save as:</label>
                <input
                  type="text"
                  className="form-control"
                  value={temporaryAssignmentName}
                  onChange={(e) => handleAssignmentName(e)}
                />
              </div>
            )}
          </div>
          {!neverShow && (
            <div className="p-3">
              <p className="mb-3 error">
                {content !== ''
                  ? replaceName
                    ? 'Assignment owned by you already exists'
                    : 'Assignment already exists and cannot be modified because it is owned by another teacher.'
                  : ''}
              </p>
            </div>
          )}
          {!neverShow && (
            <div className={'d-flex justify-content-center gap-2'}>
              <button
                className="btn btn-castleWhite"
                style={{width:'100px'}}
                onClick={() => validateData(temporaryAssignmentName)}>
                {saveButton}
              </button>
              <button
                className="btn btn-castleRed"
                style={{width:'100px'}}
                onClick={() => {
                  onClose();
                  setNeverShow(true);
                }}>
                {cancelButton}
              </button>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

WarningAlert.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  replaceName: PropTypes.bool,
  isLoading: PropTypes.bool,
  content: PropTypes.string,
  setContent: PropTypes.func,
  contentWidth: PropTypes.string,
  saveButton: PropTypes.string,
  cancelButton: PropTypes.string,
  replaceData: PropTypes.func,
  validateData: PropTypes.func
};

export default WarningAlert;
